import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notice the voice",
    opening: localizedGenderNode(
      [
      "Today I don't try to silence the voice.",
      "I just notice it.",
      "That is enough for now."
    ],
      [
      "Today I don't try to silence the voice.",
      "I just notice it.",
      "That is enough for now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does the critical voice wake up?",
      "What does it usually tell me?",
      "How does it feel in my body?"
    ],
      [
      "When does the critical voice wake up?",
      "What does it usually tell me?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing the voice is already a beginning."
    ],
      [
      "Noticing the voice is already a beginning."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the words \"I am here\".",
      "one breath with the words \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Where it comes from",
    opening: localizedGenderNode(
      [
      "Today I notice where the voice came from.",
      "Without blame.",
      "Just to see."
    ],
      [
      "Today I notice where the voice came from.",
      "Without blame.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my chest."
    ],
      [
      "I breathe slowly.",
      "I feel my chest."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "From whom did I learn this voice?",
      "When did I hear it first?",
      "What did it do to me then?"
    ],
      [
      "From whom did I learn this voice?",
      "When did I hear it first?",
      "What did it do to me then?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Seeing the source softens the present."
    ],
      [
      "Seeing the source softens the present."
    ]
    ),
    action: localizedGenderNode(
      "write one word about the source.",
      "write one word about the source."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "What it tries to prevent",
    opening: localizedGenderNode(
      [
      "Today I ask what the voice tries to prevent.",
      "Not to justify.",
      "Just to understand."
    ],
      [
      "Today I ask what the voice tries to prevent.",
      "Not to justify.",
      "Just to understand."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does the voice fear will happen if I let go?",
      "What is it trying to protect me from?",
      "What is the cost of that for me?"
    ],
      [
      "What does the voice fear will happen if I let go?",
      "What is it trying to protect me from?",
      "What is the cost of that for me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Even that voice tries to protect me."
    ],
      [
      "Even that voice tries to protect me."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I see you\".",
      "tell myself \"I see you\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The part that was hurt",
    opening: localizedGenderNode(
      [
      "Today I notice the part hurt by that voice.",
      "Not to fix.",
      "Just to be with it."
    ],
      [
      "Today I notice the part hurt by that voice.",
      "Not to fix.",
      "Just to be with it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does it sit in me?",
      "What does it need from me now?",
      "How does it feel to be with it for a moment?"
    ],
      [
      "Where does it sit in me?",
      "What does it need from me now?",
      "How does it feel to be with it for a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Being with it for a moment is already a small change."
    ],
      [
      "Being with it for a moment is already a small change."
    ]
    ),
    action: localizedGenderNode(
      "place a hand on my heart and breathe.",
      "place a hand on my heart and breathe."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Seeing the cost",
    opening: localizedGenderNode(
      [
      "Today I see the cost the voice takes.",
      "Not to blame.",
      "Just to see."
    ],
      [
      "Today I see the cost the voice takes.",
      "Not to blame.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the cost I pay for this voice?",
      "What do I lose along the way?",
      "What would I want to be different?"
    ],
      [
      "What is the cost I pay for this voice?",
      "What do I lose along the way?",
      "What would I want to be different?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Seeing the cost opens space for a small change."
    ],
      [
      "Seeing the cost opens space for a small change."
    ]
    ),
    action: localizedGenderNode(
      "write one word about the cost.",
      "write one word about the cost."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Asking for gentleness",
    opening: localizedGenderNode(
      [
      "Today I form a small request for gentleness.",
      "Not big.",
      "Just small."
    ],
      [
      "Today I form a small request for gentleness.",
      "Not big.",
      "Just small."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How would I want to be spoken to?",
      "How can I speak that way to myself?",
      "What is a small step toward it?"
    ],
      [
      "How would I want to be spoken to?",
      "How can I speak that way to myself?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small gentleness can open a breath."
    ],
      [
      "A small gentleness can open a breath."
    ]
    ),
    action: localizedGenderNode(
      "one gentle sentence to myself.",
      "one gentle sentence to myself."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Staying with myself",
    opening: localizedGenderNode(
      [
      "Today I practice staying with myself facing the voice.",
      "Not running away.",
      "Just being."
    ],
      [
      "Today I practice staying with myself facing the voice.",
      "Not running away.",
      "Just being."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What helps me stay with me?",
      "What takes me away from me?",
      "What could help me return?"
    ],
      [
      "What helps me stay with me?",
      "What takes me away from me?",
      "What could help me return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Staying with me is a small repair."
    ],
      [
      "Staying with me is a small repair."
    ]
    ),
    action: localizedGenderNode(
      "one breath before a response.",
      "one breath before a response."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A boundary with the voice",
    opening: localizedGenderNode(
      [
      "Today I check a small boundary with the voice.",
      "Not to fight.",
      "Just to protect."
    ],
      [
      "Today I check a small boundary with the voice.",
      "Not to fight.",
      "Just to protect."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ],
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does the voice cross a line for me?",
      "What boundary sentence would help?",
      "How can I say it to myself?"
    ],
      [
      "When does the voice cross a line for me?",
      "What boundary sentence would help?",
      "How can I say it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small boundary protects the heart."
    ],
      [
      "A small boundary protects the heart."
    ]
    ),
    action: localizedGenderNode(
      "one boundary sentence to myself.",
      "one boundary sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Hearing another voice too",
    opening: localizedGenderNode(
      [
      "Today I check if there is another voice in me.",
      "Small.",
      "But it exists."
    ],
      [
      "Today I check if there is another voice in me.",
      "Small.",
      "But it exists."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does a gentler voice tell me?",
      "When do I hear it?",
      "How does it feel to hear it?"
    ],
      [
      "What does a gentler voice tell me?",
      "When do I hear it?",
      "How does it feel to hear it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One gentle voice can open space."
    ],
      [
      "One gentle voice can open space."
    ]
    ),
    action: localizedGenderNode(
      "write one gentle sentence.",
      "write one gentle sentence."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Asking for gentle touch",
    opening: localizedGenderNode(
      [
      "Today I check how to ask for gentle touch.",
      "No drama.",
      "A small request."
    ],
      [
      "Today I check how to ask for gentle touch.",
      "No drama.",
      "A small request."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What gentle touch do I miss?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ],
      [
      "What gentle touch do I miss?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can soften things."
    ],
      [
      "One request can soften things."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "One value beyond criticism",
    opening: localizedGenderNode(
      [
      "Today I look for one value beyond the critical voice.",
      "Small.",
      "But true."
    ],
      [
      "Today I look for one value beyond the critical voice.",
      "Small.",
      "But true."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which value truly matters to me?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ],
      [
      "Which value truly matters to me?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One value can be an anchor."
    ],
      [
      "One value can be an anchor."
    ]
    ),
    action: localizedGenderNode(
      "one word that expresses the value.",
      "one word that expresses the value."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Listening to me",
    opening: localizedGenderNode(
      [
      "Today I practice listening to me against the critical voice.",
      "Not to push away.",
      "Just to hear."
    ],
      [
      "Today I practice listening to me against the critical voice.",
      "Not to push away.",
      "Just to hear."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to hear from myself today?",
      "What do I give others that I don't give me?",
      "How can I give it to myself?"
    ],
      [
      "What do I need to hear from myself today?",
      "What do I give others that I don't give me?",
      "How can I give it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Listening to me is a small repair."
    ],
      [
      "Listening to me is a small repair."
    ]
    ),
    action: localizedGenderNode(
      "one gentle sentence to myself.",
      "one gentle sentence to myself."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A small step of acceptance",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of acceptance.",
      "No drama.",
      "A small step."
    ],
      [
      "Today I choose a small step of acceptance.",
      "No drama.",
      "A small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ],
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step is enough to move."
    ],
      [
      "A small step is enough to move."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a sentence that brings me back to inner gentleness.",
      "When I feel judged.",
      "A small sentence."
    ],
      [
      "Today I choose a sentence that brings me back to inner gentleness.",
      "When I feel judged.",
      "A small sentence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this voice?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ],
      [
      "What did I learn about this voice?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can hear criticism and still stay with myself."
    ],
      [
      "I can hear criticism and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "say the new sentence once.",
      "say the new sentence once."
    ),
  },
].map(buildNormalizedDay);

export const harshCriticismOfAParentThatLivesInsideMeToThisDayBlueprintEn = buildNormalizedPilotBlueprint({
  id: "harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "ביקורתיות חריפה של הורה שחיה בתוכי עד היום",
    en: "Harsh criticism of a parent that lives inside me to this day",
    es: "Crítica dura de un padre que vive dentro de mí hasta hoy",
  },
  days,
});

export default harshCriticismOfAParentThatLivesInsideMeToThisDayBlueprintEn;
